import { Injectable } from '@angular/core';
import {
  ConfigurationType,
  KebaWallboxPlugin,
} from '../../../../../apps/keba-wallbox-app/src/plugins/keba-wallbox-plugin';
import {
  LocalWallboxSettingsService,
  WallboxAppConfiguration,
} from '../../../../../apps/keba-wallbox-app/src/app/services/local-wallbox/settings/local-wallbox-settings.service';
import { CurrentWallboxConfigService } from '../../../../../apps/keba-wallbox-app/src/app/services/current-wallbox-config.service';
import { IClusterService } from '../IClusterService';
import { Cluster, ClusterKey } from '@kw-shared/common';

@Injectable({
  providedIn: 'root',
})
export class LocalClusterService implements IClusterService {
  public constructor(
    private readonly localWallboxSettingsService: LocalWallboxSettingsService,
    private readonly currentWallboxConfigService: CurrentWallboxConfigService
  ) {}

  public async readClustersEnabled(): Promise<boolean> {
    let resp = await this.localWallboxSettingsService.readConfiguration(
      ConfigurationType.LMGMT,
      ClusterKey.CLUSTERS_ENABLE
    );
    return resp != undefined && resp[ClusterKey.CLUSTERS_ENABLE] === 'true';
  }

  public async writeClustersEnabled(enabled: boolean): Promise<void> {
    await this.localWallboxSettingsService.writeConfiguration(ConfigurationType.LMGMT, {
      configs: [{ key: ClusterKey.CLUSTERS_ENABLE, value: enabled.toString() }],
    });
  }

  public readClusters(): Promise<{ clusters: Cluster[] }> {
    let config = this.getWallboxConfig();
    if (!config) {
      return Promise.reject();
    }
    return KebaWallboxPlugin.readClusters({ config });
  }

  public createCluster(cluster: Cluster): Promise<void> {
    let config = this.getWallboxConfig();
    if (!config) {
      return Promise.reject();
    }
    return KebaWallboxPlugin.createCluster({ config, ...cluster });
  }

  public updateCluster(cluster: Cluster): Promise<void> {
    let config = this.getWallboxConfig();
    if (!config) {
      return Promise.reject();
    }
    return KebaWallboxPlugin.updateCluster({ config, ...cluster });
  }

  public deleteCluster(cluster: Cluster): Promise<void> {
    let config = this.getWallboxConfig();
    if (!config) {
      return Promise.reject();
    }
    return KebaWallboxPlugin.deleteCluster({ config, number: cluster.number });
  }

  public setClusters(clusters: Cluster[], wallboxId?: string): Promise<void> {
    throw new Error('Method not implemented.');
  }

  public getWallboxConfig(): WallboxAppConfiguration | undefined {
    const wallboxConfig = this.currentWallboxConfigService.getCurrentWallboxConfig();
    if (wallboxConfig?.isLocalWallbox()) {
      return wallboxConfig.toWallboxConfiguration();
    }
    return undefined;
  }
}
